.container {
  width: 100%;
  height: 37rem;
  padding: 1.6rem;
  overflow: hidden;
  border-radius: 1.6rem;
}

.emptyContainer {
  background-color: var(--color-white);
  border: 0.1rem dashed var(--color-mabel);
  box-shadow: 0 1rem 2rem rgba(var(--color-black-rgb), 0.02);
}

.placeholderLabel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.dropActive {
  background-color: rgba(var(--color-mabel-rgb), 0.4);
}

.dropLabel {
  color: var(--color-semantic-text-neutral20);
  font-weight: bold;
}

.placeholderTitle {
  margin-top: 1.6rem;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  text-align: center;
}

.placeholderDescription {
  margin-top: 0.8rem;
  color: rgba(var(--color-oxfor-blue-rgb), 0.5);
  font-size: 1.2rem;
  text-align: center;
}

.iconHolder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.8rem;
  height: 4.8rem;
  font-weight: bold;
  font-size: 1.2rem;
  background-color: rgba(var(--color-gumbo-rgb), 0.4);
  border-radius: 1rem;
}

.thumbnails {
  display: flex;
  align-items: center;
  margin-top: 1.2rem;
}

.addNewBtn {
  padding: 0.9rem 1.8rem;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1.4rem;
  background: var(--color-action-secondary--bold);
  border-radius: 0.8rem;
  cursor: pointer;
}
